import React from 'react';
import logo from './logo.svg';

import { Routes,Route,Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import './App.css';
import Login from './features/login/Login';
import Summary from './features/summary/Summary';
import Alarm from './features/alarm/Alarm';
import Log from './features/log/Log';
import Check from './features/check/Check';
import { selectIsLoggedIn } from './features/login/LoginSlice';


 const App = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (isLoggedIn)
    return (
      <Routes>
          {/*<Route exact path="/" element={<Summary/>} />*/}
          <Route path="/summary" element={<Summary/>} />
          <Route path="/alarm" element={<Alarm/>} />
          <Route path="/log" element={<Log/>} />
          <Route path="/check" element={<Check/>} />
          {/*<Route path="/login"  element={<Login/>} />*/}
          {/*<Route path="/" element={<Summary/>} />*/}
          <Route path="/*" element={<Summary/>} />
      </Routes>
    );
  else
    return (
      <Routes>
          {/*<Route exact path="/" element={<Navigate to="/login"/>} />*/}
          <Route path="/summary" element={<Navigate to="/login"/>} />
          <Route path="/alarm" element={<Navigate to="/login"/>} />
          <Route path="/log" element={<Navigate to="/login"/>} />
          <Route path="/check" element={<Navigate to="/login"/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/*" element={<Login/>} />
      </Routes>
    );
};

export default App;
